import assign = require('object-assign');
import { FETCH_REQUEST, FETCH_SUCCESS, FETCH_FAILURE } from '../constants/Authentication';

import { IAuthenticationState } from '../interfaces/states';

import { defaultFactory } from '../api/RequestFactory';

const initialState: IAuthenticationState = {
    authenticated: false
};

export default function states(state = initialState, action): IAuthenticationState {
    switch (action.type) {
        case FETCH_REQUEST: {
            return assign({}, state, {
                loading: true
            });
        }
        case FETCH_SUCCESS: {
            return assign({}, state, {
                loading: false,
                authenticated: true,
            });
        }
        case FETCH_FAILURE: {
            return assign({}, state, {
                loading: false,
                error: action.error,
                authenticated: false,
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/authentication.ts